"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.containerNames = exports.checksumAlgorithms = exports.fileCreators = void 0;
exports.fileCreators = ['SERVER', 'BOX', 'WORKER', 'AUTO_TRANSFORM'];
exports.checksumAlgorithms = ['MD5'];
exports.containerNames = [
    'language-assets',
    'datapoint',
    'report',
    'exports',
    'audioprompts',
    'conferencer',
    'worker-certificates',
    'worker-profile-picture',
    'worker-resume',
    'form-data',
];
//# sourceMappingURL=Files.js.map